import { render, staticRenderFns } from "./CardTabs.vue?vue&type=template&id=489ff53c&"
import script from "./CardTabs.vue?vue&type=script&lang=js&"
export * from "./CardTabs.vue?vue&type=script&lang=js&"
import style0 from "./CardTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports